<div class="profile-page">

  <!-- Back to Home -->
  <a routerLink="/" class="back-link">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="back-icon">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
    Back to Home
  </a>

  <!-- Left sidebar -->
  <div class="profile-content">
  <aside class="profile-sidebar">
    <div class="sidebar-header">
      <div class="avatar-circle">
        <span>{{ firstInitial }}</span>
      </div>
      <div class="sidebar-name">{{ displayName }}</div>
      <div class="sidebar-email">{{ displayEmail }}</div>
    </div>

    <nav class="sidebar-nav">
      <button
        class="nav-item"
        [class.active]="activeTab === 'profile'"
        (click)="setTab('profile')">
        <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
        </svg>
        Profile Information
      </button>
      <button
        class="nav-item"
        [class.active]="activeTab === 'developer'"
        (click)="setTab('developer')">
        <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
        </svg>
        Developer Settings
      </button>
    </nav>
  </aside>

  <!-- Main content area -->
  <main class="profile-main">

    <!-- ── Tab: Profile Information ── -->
    <section *ngIf="activeTab === 'profile'">
      <h2 class="section-title">Profile Information</h2>
      <p class="section-subtitle">Your account details as provided by the organisation's identity system.</p>

      <div class="card">
        <table class="claims-table">
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let claim of claims">
              <td class="claim-label">{{ claim.label }}</td>
              <td class="claim-value">{{ claim.value }}</td>
            </tr>
            <tr *ngIf="claims.length === 0">
              <td colspan="2" class="empty-state">No token claims available. Please log in.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Last Logins -->
      <h3 class="section-title mt-8">Last Logins</h3>
      <p class="section-subtitle">Recent authentication events (last 10 days).</p>

      <div class="card" *ngIf="loginHistoryError">
        <p style="color:#c0392b; margin:0 0 12px">{{ loginHistoryError }}</p>
        <button class="btn-open-modal" (click)="loadLoginHistory()">Retry</button>
      </div>

      <div class="card" *ngIf="!loginHistoryError">
        <table class="claims-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Auth Method</th>
              <th>Requests</th>
              <th>Last Request</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="loginHistoryLoading">
              <tr *ngFor="let _ of [1,2,3]">
                <td><div class="skeleton" style="width:90px;height:12px"></div></td>
                <td><div class="skeleton" style="width:130px;height:12px"></div></td>
                <td><div class="skeleton" style="width:40px;height:12px"></div></td>
                <td><div class="skeleton" style="width:140px;height:12px"></div></td>
              </tr>
            </ng-container>
            <tr *ngIf="!loginHistoryLoading && loginHistory.length === 0">
              <td colspan="4" style="text-align:center; color:#999; padding:24px; font-style:italic">No login history found.</td>
            </tr>
            <tr *ngFor="let entry of loginHistory">
              <td>{{ entry.loginDate }}</td>
              <td>{{ entry.loginType }}</td>
              <td style="text-align:right">{{ entry.requestsCount }}</td>
              <td style="font-size:12px; color:#555">{{ entry.lastRequestAt ? (entry.lastRequestAt | date:'dd MMM yyyy, HH:mm') : '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- ── Tab: Developer Settings ── -->
    <section *ngIf="activeTab === 'developer'">
      <h2 class="section-title">Developer Settings</h2>
      <p class="section-subtitle">Manage API keys for programmatic access to the URL Shortener API.</p>

      <!-- Top action bar -->
      <div class="section-actions" *ngIf="!credentialLoading && !credentialError">
        <button class="btn-open-modal" (click)="openApiKeyModal()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="btn-icon">
            <circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 010 14.14M4.93 4.93a10 10 0 000 14.14"/>
          </svg>
          Register API Key
        </button>
      </div>

      <!-- Error -->
      <div class="card" *ngIf="!credentialLoading && credentialError">
        <p style="color:#c0392b; margin:0 0 12px">{{ credentialError }}</p>
        <button class="btn-open-modal" (click)="loadCredentials()">Retry</button>
      </div>

      <!-- API keys table -->
      <div class="card" *ngIf="!credentialError" style="overflow-x:auto">
        <table class="claims-table" style="table-layout:fixed; min-width:420px">
          <thead>
            <tr>
              <th style="width:28%">Name</th>
              <th style="width:17%">Type</th>
              <th style="width:15%">Status</th>
              <th style="width:13%">Role</th>
              <th style="width:17%">Created at</th>
              <th style="width:10%; text-align:right"></th>
            </tr>
          </thead>
          <tbody>
            <!-- Loading skeletons -->
            <ng-container *ngIf="credentialLoading">
              <tr *ngFor="let _ of [1,2]">
                <td><div class="skeleton" style="width:120px;height:12px"></div></td>
                <td><div class="skeleton" style="width:80px;height:12px"></div></td>
                <td><div class="skeleton" style="width:80px;height:12px"></div></td>
                <td><div class="skeleton" style="width:50px;height:12px"></div></td>
                <td><div class="skeleton" style="width:100px;height:12px"></div></td>
                <td></td>
              </tr>
            </ng-container>
            <!-- Empty state -->
            <tr *ngIf="!credentialLoading && credentials.length === 0">
              <td colspan="6" style="text-align:center; color:#999; padding:24px; font-style:italic">
                No API keys registered yet. Click "Register API Key" to get started.
              </td>
            </tr>
            <!-- Real rows -->
            <tr *ngFor="let cred of credentials">
              <td style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap" [title]="cred.name || ''">{{ cred.name || '—' }}</td>
              <td>
                <span *ngIf="cred.hasApiKey && cred.hasBasicCredential">API Key + Basic Auth</span>
                <span *ngIf="cred.hasApiKey && !cred.hasBasicCredential">API Key</span>
                <span *ngIf="!cred.hasApiKey && cred.hasBasicCredential">Basic Auth</span>
                <span *ngIf="!cred.hasApiKey && !cred.hasBasicCredential" style="color:#999">—</span>
              </td>
              <td>
                <span *ngIf="cred.hasApiKey || cred.hasBasicCredential" style="color:#27ae60; font-weight:600">&#10003; Active</span>
                <span *ngIf="!cred.hasApiKey && !cred.hasBasicCredential" style="color:#e67e22; font-weight:600">&#9888; No key</span>
              </td>
              <td>{{ cred.role === 'admin' ? 'Admin' : cred.role }}</td>
              <td style="font-size:12px; color:#555">{{ cred.createdAt ? (cred.createdAt | date:'dd MMM yyyy, HH:mm') : '—' }}</td>
              <td style="text-align:right; padding-right:8px">
                <button class="btn-revoke" (click)="revokeCredential(cred)" [title]="'Revoke ' + (cred.name || 'this key')" style="padding:4px 7px; line-height:1">
                  <img src="../ui/assets/img/delete.svg" alt="Revoke" style="width:18px;height:18px;vertical-align:middle;filter:invert(20%) sepia(80%) saturate(700%) hue-rotate(330deg)" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

  </main>
  </div>

  <!-- ── API Key Modal ── -->
  <div class="modal-backdrop" *ngIf="apiKeyModalOpen" (click)="closeApiKeyModal()"></div>
  <div class="modal" *ngIf="apiKeyModalOpen" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3 class="modal-title">Register API Key</h3>
      <button class="modal-close" (click)="closeApiKeyModal()" aria-label="Close">&times;</button>
    </div>

    <div class="modal-body">
      <!-- Error message -->
      <p *ngIf="modalError" style="color:#c0392b; font-size:13px; margin:0 0 12px">{{ modalError }}</p>

      <!-- Key name (required for both modes) -->
      <div style="margin-bottom:14px">
        <label style="display:block; font-size:13px; font-weight:600; color:#333; margin-bottom:5px">Key name <span style="color:#c0392b">*</span></label>
        <input
          type="text"
          class="modal-input"
          [class.modal-input--error]="keyNameTouched && !keyName.trim()"
          [(ngModel)]="keyName"
          placeholder="e.g. CI pipeline, Personal laptop" />
        <p *ngIf="keyNameTouched && !keyName.trim()" style="color:#c0392b; font-size:12px; margin:4px 0 0">Please enter a name for this key.</p>
      </div>

      <!-- Option: I already have a key -->
      <div class="radio-content" *ngIf="apiKeyMode === 'existing'">
        <input
          type="text"
          class="modal-input"
          [(ngModel)]="existingKey"
          placeholder="Paste your API key here" />
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeApiKeyModal()" [disabled]="modalStep === 'saving'">Cancel</button>
      <button class="btn-ok" (click)="confirmApiKey()" [disabled]="modalStep === 'saving'">
        {{ modalStep === 'saving' ? 'Saving…' : 'OK' }}
      </button>
    </div>
  </div>

</div>
